import React from 'react'
import {store} from "../Redux/store"
import { Provider } from "react-redux";
import ChatScreen from './chatScreen';
import PropTypes from 'prop-types';

export const ChatApp = (props)=>{
     return (
     <Provider store={store}>
          <ChatScreen initial={props}/>
     </Provider>
          );
    }

ChatApp.propTypes ={
     // apiUrl:PropTypes.string.isRequired,
     licenseKey:PropTypes.string.isRequired,
     userIdentifier:PropTypes.string.isRequired,
     // isSandBox:PropTypes.bool.isRequired,
     theme:PropTypes.oneOf(['light', 'dark']),
     colorSet:PropTypes.object,
     iconSet:PropTypes.object,
     width:PropTypes.string,
     height:PropTypes.string,
     enableMobileView:PropTypes.bool,
     enableDeviceSize:PropTypes.bool,
     isCallEnabled:PropTypes.bool,
}